import { ApiResult, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

export class AccountApi {
    constructor(protected baseUrl: string) {}

    public updateAccountLastChecked(): Promise<ApiResult<void>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/update-account-last-checked`, { lastCheckedDate: new Date() }),
            noop
        );
    }
}
